function autoAddClassOnViewport() {
    let $elements = $('.j-autoclass');
    if ($elements.length === 0) return;

    function isMobileByScreenWidth() {
        return window.innerWidth <= 768;
    }

    if (isMobileByScreenWidth()) {
        console.log('Mobile device detected. Skipping auto-class for elements with j-no-mobile.');
        $elements = $elements.not('.j-no-mobile')
        if ($elements.length == 0) return
    }

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            const $element = $(entry.target);
            const classToAdd = $element.data('class');
            const state = $element.data('animation-state');
            const isOnce = $element.hasClass('j-once'); // 检查是否有 j-once 类

            if (entry.isIntersecting && entry.intersectionRatio > 0) {
                if (state === undefined) {
                    // 未进入动画状态，添加 class 并标记为准备动画状态
                    if (classToAdd) {
                        $element.addClass(classToAdd);
                        $element.data('animation-state', 'preparing');
                        // 监听动画结束事件
                        $element.on('animationend', function () {
                            $element.data('animation-state', 'finished');
                        });
                    }
                }
            } else {
                if (!isOnce && state === 'finished') {
                    // 如果没有 j-once 类，移出范围时移除 class 并重置状态
                    if (classToAdd) {
                        $element.removeClass(classToAdd);
                        $element.removeData('animation-state');
                    }
                }
            }
        });
    }, {
        threshold: 0.3,
    });

    $elements.each(function () {
        $(this).css('opacity', '0');
        observer.observe(this);
    });
}

// 当文档就绪时调用该方法
$(document).ready(function () {
    autoAddClassOnViewport();
});
